import React from 'react';
import { NavLink } from 'react-router-dom';
import useLegalVersions from '../../hooks/useLegalVersions';

const PrivacyPolicy = () => {
  const versions = useLegalVersions();
  return (
    <div className="container my-5 legal-document">
      <h1 className="mb-2">Privacy Notice</h1>
      <p className="text-muted">Version {versions.privacy.version} · Effective {versions.privacy.effectiveDate}</p>
      <p>MyCommunity Services processes resident information to operate the community services selected by your community. This notice explains the principal categories and purposes in clear language.</p>

      <h3>Information we process</h3>
      <p>Account and contact details; community, home and resident relationships; vehicles and visitors; bookings, helpdesk, notices and parcels; poll and event responses; documents you upload; finance transactions and evidence; security, audit and limited access-analytics records.</p>

      <h3>Why we process it</h3>
      <ul>
        <li>To register, authenticate and administer resident accounts.</li>
        <li>To deliver the community modules enabled by your community.</li>
        <li>To communicate notices, workflow decisions and service updates.</li>
        <li>To secure the platform, investigate misuse and maintain audit history.</li>
        <li>To meet lawful accounting, security and operational obligations.</li>
      </ul>

      <h3>Access and sharing</h3>
      <p>Access is limited by role and community. Community administrators manage their own community records. We may use contracted infrastructure, email, notification and coarse geolocation providers to operate the service; they may process only the information needed for their service.</p>

      <h3>Retention and security</h3>
      <p>Records are retained according to their operational, contractual, security and legal purpose. Application access analytics are removed after the configured period (90 days by default), and visitor history follows the community retention setting. We use access controls, encryption in transit, backups, monitoring and audit records to protect information.</p>

      <h3>Your choices and rights</h3>
      <p>You may ask to access, correct or export your information, withdraw consent, request deletion where applicable, or raise a grievance. Some finance, security or audit records may need to be retained or anonymized instead of immediately deleted.</p>

      <h3>Contact and requests</h3>
      <p>Contact your Community Administrator or MyCommunity support with privacy questions. Signed-in users can track a request from the <NavLink to="/profile">Privacy &amp; Data Requests</NavLink> section of their profile.</p>
    </div>
  );
};

export default PrivacyPolicy;
